<div class="flex h-content justify-center items-center">
    <div class="text-center space-y-2 -mt-14">
        <div class="font-[1000] text-[150px] md:text-[250px] text-gray-800 relative flex justify-center">
            4<span class="text-gray-100 mx-2 md:mx-5">0</span>4
            <div class="flex flex-col justify-center items-center z-10 absolute bottom-16 md:bottom-28">
                <div>
                    <img src="assets/images/forbidden.png" class="w-28 md:w-48">
                </div>
            </div>
        </div>
        <div>
            <h2 class="font-bold text-2xl">
                Not Found
            </h2>
            <div class="text-gray-600">
                The page you are looking for doesn't exist.
            </div>
        </div>
    </div>
</div>